import { render, staticRenderFns } from "./CompanyGroupLocalizationsCard.vue?vue&type=template&id=29fb0ec4&scoped=true&"
import script from "./CompanyGroupLocalizationsCard.vue?vue&type=script&lang=js&"
export * from "./CompanyGroupLocalizationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb0ec4",
  null
  
)

export default component.exports